if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener(
              'click',
              this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false)
            );
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        if (!event.detail?.currentElement || !this.elements.thumbnails) return;

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );

        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );

        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );

            if (activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }

          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );

        this.setActiveThumbnail(activeThumbnail);

        if (activeThumbnail) {
          this.announceLiveRegion(
            activeMedia,
            activeThumbnail.dataset.mediaPosition
          );
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));

        thumbnail.querySelector('button').setAttribute('aria-current', true);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);

          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );

          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();

        const deferredMedia = activeItem.querySelector('.deferred-media');

        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute('role', 'presentation');

        this.elements.viewer.sliderItems.forEach((slide) => {
          slide.setAttribute('role', 'presentation');
        });
      }
    }
  );
}

/*
  BÁRZAGA: galería con desplazamiento nativo en móvil/tablet.
  Revisión 2: todas las imágenes comparten una altura estable; sin recorte.
  Sustituye el archivo completo. No cargar junto a otra copia del controlador.
  Desktop layout: Thumbnails o Thumbnail carousel.
*/

(() => {
  if (window.barzagaGalleryInstalled) return;
  window.barzagaGalleryInstalled = true;

  const instances = new WeakMap();
  const spanish = document.documentElement.lang.toLowerCase().startsWith('es');

  const labels = spanish
    ? {
        previous: 'Imagen anterior',
        next: 'Imagen siguiente',
        close: 'Cerrar',
        gallery: 'Galería de imágenes',
        image: 'Imagen',
      }
    : {
        previous: 'Previous image',
        next: 'Next image',
        close: 'Close',
        gallery: 'Image gallery',
        image: 'Image',
      };

  const style = document.createElement('style');
  style.id = 'barzaga-gallery-style';

  style.textContent = `
    media-gallery.bz-gallery [id^="GalleryThumbnails"],
    media-gallery.bz-gallery [id^="GalleryViewer"] > .slider-buttons {
      display: none !important;
    }

    media-gallery.bz-gallery [id^="GalleryViewer"] {
      display: block;
      position: relative;
      margin: 0;
    }

    media-gallery.bz-gallery .product__media-list {
      display: block !important;
      width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;
      scroll-snap-type: none !important;
      touch-action: pan-y pinch-zoom;
    }

    media-gallery.bz-gallery .product__media-list::after {
      display: none !important;
    }

    media-gallery.bz-gallery .product__media-list > [data-media-id] {
      display: none !important;
    }

    media-gallery.bz-gallery .product__media-list > [data-media-id].is-active {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    media-gallery.bz-gallery .product__media img {
      object-fit: contain !important;
    }

    /* Mobile/tablet: native scrolling, not display:none image switching. */

    media-gallery.bz-gallery.bz-native-swipe .product__media-list {
      display: flex !important;
      flex-direction: row !important;
      flex-wrap: nowrap !important;
      align-items: stretch !important;
      gap: 0 !important;
      box-sizing: border-box !important;
      height: var(--bz-native-height, auto) !important;
      min-height: 0 !important;
      aspect-ratio: 1 / 1;
      overflow-x: auto !important;
      overflow-y: hidden !important;
      scroll-snap-type: x mandatory !important;
      scroll-padding: 0 !important;
      scroll-behavior: auto !important;
      touch-action: pan-x pan-y pinch-zoom !important;
      overscroll-behavior-x: contain;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
    }

    media-gallery.bz-gallery.bz-native-swipe .product__media-list::-webkit-scrollbar {
      display: none !important;
    }

    media-gallery.bz-gallery.bz-native-swipe .product__media-list > [data-media-id],
    media-gallery.bz-gallery.bz-native-swipe .product__media-list > [data-media-id].is-active {
      display: block !important;
      flex: 0 0 100% !important;
      box-sizing: border-box !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      height: 100% !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      scroll-snap-align: start !important;
      scroll-snap-stop: always;
      scroll-margin: 0 !important;
      opacity: 1 !important;
      transform: none !important;
      animation: none !important;
    }

    media-gallery.bz-gallery.bz-native-swipe .product__media-list > [data-media-id]:not([data-bz-visible="true"]) {
      display: none !important;
    }

    /* Definite height at every layer overrides the earlier padding-top sizing. */

    media-gallery.bz-gallery.bz-native-swipe .product__media-list > [data-media-id] > .product-media-container {
      width: 100% !important;
      max-width: 100% !important;
      height: 100% !important;
      min-height: 0 !important;
      max-height: none !important;
      aspect-ratio: auto !important;
      margin: 0 !important;
      padding: 0 !important;
      box-sizing: border-box !important;
    }

    media-gallery.bz-gallery.bz-native-swipe .product__modal-opener,
    media-gallery.bz-gallery.bz-native-swipe .product__media-list .deferred-media {
      width: 100% !important;
      height: 100% !important;
      min-height: 0 !important;
    }

    media-gallery.bz-gallery.bz-native-swipe .product-media-container .product__media.media {
      position: relative !important;
      display: block !important;
      box-sizing: border-box !important;
      width: 100% !important;
      height: 100% !important;
      min-height: 0 !important;
      padding: 0 !important;
      aspect-ratio: auto !important;
      background: transparent !important;
    }

    media-gallery.bz-gallery.bz-native-swipe .product__media img {
      position: absolute !important;
      inset: 0 !important;
      width: 100% !important;
      height: 100% !important;
      max-height: 100% !important;
      object-fit: contain !important;
      object-position: center !important;
      user-select: none;
      -webkit-user-drag: none;
    }

    media-gallery.bz-gallery.bz-native-swipe .product__modal-opener,
    media-gallery.bz-gallery.bz-native-swipe .product__media-toggle {
      touch-action: pan-x pan-y pinch-zoom !important;
    }

    media-gallery.bz-gallery.bz-native-swipe .bz-arrow {
      display: none !important;
    }

    media-gallery.bz-gallery.bz-native-swipe.bz-mouse-dragging .product__media-list {
      scroll-snap-type: none !important;
      cursor: grabbing;
      user-select: none;
    }

    .bz-arrow,
    .bz-close {
      appearance: none;
      display: grid;
      place-items: center;
      position: absolute;
      z-index: 3;
      width: 44px;
      height: 44px;
      padding: 10px;
      border: 0;
      border-radius: 0;
      background: transparent;
      color: #111;
      cursor: pointer;
      box-shadow: none;
      touch-action: manipulation;
    }

    .bz-arrow {
      top: 50%;
      transform: translateY(-50%);
    }

    .bz-previous {
      left: 4px;
    }

    .bz-next {
      right: 4px;
    }

    .bz-arrow svg,
    .bz-close svg {
      width: 22px;
      height: 22px;
      fill: none;
      stroke: currentColor;
      stroke-width: 1.5;
      pointer-events: none;
    }

    .bz-close {
      top: max(10px, env(safe-area-inset-top));
      right: max(10px, env(safe-area-inset-right));
    }

    .bz-dots {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 2px;
      margin: 10px auto 0;
      padding: 0;
    }

    .bz-dot {
      appearance: none;
      display: grid;
      place-items: center;
      width: 28px;
      height: 28px;
      padding: 0;
      border: 0;
      background: transparent;
      cursor: pointer;
      box-shadow: none;
      touch-action: manipulation;
    }

    .bz-dot::after {
      content: '';
      display: block;
      width: 22px;
      height: 2px;
      background: #aaa;
    }

    .bz-dot[aria-current="true"]::after {
      background: #111;
    }

    .bz-arrow:focus-visible,
    .bz-close:focus-visible,
    .bz-dot:focus-visible {
      outline: 2px solid #111;
      outline-offset: 2px;
    }

    .bz-arrow[hidden],
    .bz-dots[hidden] {
      display: none !important;
    }

    dialog.bz-lightbox {
      box-sizing: border-box;
      position: fixed;
      inset: 0;
      margin: 0;
      width: 100%;
      max-width: none;
      height: 100vh;
      height: 100dvh;
      max-height: none;
      padding: 55px 44px 60px;
      border: 0;
      background: #fff;
      color: #111;
      overflow: hidden;
    }

    dialog.bz-lightbox::backdrop {
      background: #fff;
    }

    .bz-lightbox-image {
      display: grid;
      place-items: center;
      width: 100%;
      height: 100%;
      touch-action: pan-y pinch-zoom;
    }

    .bz-lightbox-image img {
      display: block;
      width: 100%;
      height: 100%;
      min-height: 0;
      object-fit: contain;
      user-select: none;
      -webkit-user-drag: none;
    }

    .bz-lightbox .bz-dots {
      position: absolute;
      bottom: max(18px, env(safe-area-inset-bottom));
      left: 44px;
      right: 44px;
    }

    body.bz-lightbox-open {
      overflow: hidden !important;
    }
  `;

  document.head.append(style);

  function button(className, label, path) {
    const element = document.createElement('button');

    element.type = 'button';
    element.className = className;
    element.setAttribute('aria-label', label);

    if (path) {
      element.innerHTML =
        `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${path}"/></svg>`;
    }

    return element;
  }

  function mount(gallery) {
    if (
      instances.has(gallery) ||
      !gallery.dataset.desktopLayout?.includes('thumbnail')
    ) return;

    const viewer = gallery.elements?.viewer;
    const list = viewer?.querySelector('.product__media-list');

    if (!list || typeof gallery.setActiveMedia !== 'function') return;

    const controller = new AbortController();
    const signal = controller.signal;

    const mobileQuery = window.matchMedia('(max-width: 989px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    let nativeMode = mobileQuery.matches;
    let nativeEntries = [];
    let scrollFrame = 0;
    let resizeFrame = 0;
    let announceTimer = 0;
    let lastWidth = 0;
    let pendingTarget = null;
    let pendingTimer = 0;
    let resizing = false;

    gallery.classList.toggle('bz-native-swipe', nativeMode);

    const listen = (node, event, fn, options = {}) => {
      node.addEventListener(event, fn, { ...options, signal });
    };

    function press(node, action) {
      let down;
      let lastTouch = 0;

      listen(node, 'pointerdown', event => {
        if (event.pointerType === 'mouse' || !event.isPrimary) return;

        const target = event.target.closest('button');

        if (target && node.contains(target)) {
          down = {
            id: event.pointerId,
            target,
            x: event.clientX,
            y: event.clientY,
          };
        }
      });

      listen(node, 'pointercancel', () => {
        down = null;
      });

      listen(node, 'pointerup', event => {
        const start = down;
        down = null;

        if (
          !start ||
          start.id !== event.pointerId ||
          event.target.closest('button') !== start.target ||
          Math.hypot(event.clientX - start.x, event.clientY - start.y) > 12
        ) return;

        lastTouch = Date.now();
        event.stopPropagation();
        action(event);
      });

      listen(node, 'click', event => {
        if (event.detail && Date.now() - lastTouch < 700) {
          event.preventDefault();
          return;
        }

        action(event);
      });
    }

    const originalSetActiveMedia = gallery.setActiveMedia;

    const previous = button(
      'bz-arrow bz-previous',
      labels.previous,
      'M15 4 L7 12 L15 20'
    );

    const next = button(
      'bz-arrow bz-next',
      labels.next,
      'M9 4 L17 12 L9 20'
    );

    const dots = document.createElement('div');
    dots.className = 'bz-dots';

    viewer.append(previous, next);
    viewer.after(dots);
    gallery.classList.add('bz-gallery');

    let dialog;
    let lightboxImage;
    let lightboxDots;
    let lightboxPrevious;
    let lightboxNext;
    let opener;
    let suppressClickUntil = 0;
    let suppressCloseClickUntil = 0;

    listen(document, 'pointerdown', () => {
      suppressCloseClickUntil = 0;
    }, { capture: true });

    listen(document, 'click', event => {
      if (event.detail && Date.now() < suppressCloseClickUntil) {
        suppressCloseClickUntil = 0;
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, { capture: true });

    const sourceItems = () => Array.from(list.children).filter((item, index) =>
      item.hasAttribute('data-media-id') &&
      !item.hidden &&
      !item.classList.contains('hidden') &&
      (
        !item.classList.contains('product__media-item--variant') ||
        index === 0 ||
        item.classList.contains('is-active')
      )
    );

    const items = () => nativeMode ? nativeEntries : sourceItems();

    const photo = item => {
      return item.querySelector('.product__modal-opener--image img');
    };

    const photos = () => items().filter(photo);

    const active = () => {
      return items().find(item => item.classList.contains('is-active')) || items()[0];
    };

    function renderDots(container, entries) {
      const key = entries.map(item => item.dataset.mediaId).join('|');

      if (container.dataset.items !== key) {
        container.dataset.items = key;

        container.replaceChildren(...entries.map((item, index) => {
          const dot = button(
            'bz-dot',
            `${labels.image} ${index + 1} / ${entries.length}`
          );

          dot.dataset.mediaId = item.dataset.mediaId;
          return dot;
        }));
      }

      container.hidden = entries.length < 2;

      container.querySelectorAll('button').forEach(dot => {
        dot.setAttribute(
          'aria-current',
          String(dot.dataset.mediaId === active()?.dataset.mediaId)
        );
      });
    }

    // Width determines the common height; the active image's natural ratio does not.
    // Existing section-specific horizontal padding (e.g. scarves) is respected.

    function setNativeHeight() {
      if (!nativeMode || !nativeEntries.length || !list.clientWidth) return;

      const computed = getComputedStyle(nativeEntries[0]);
      const number = property => parseFloat(computed[property]) || 0;

      const horizontal = number('paddingLeft') + number('paddingRight');
      const vertical = number('paddingTop') + number('paddingBottom');

      const height = Math.max(1, list.clientWidth - horizontal) + vertical;

      list.style.setProperty('--bz-native-height', `${height}px`);
    }

    function scrollOffset(item) {
      const rect = list.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const left = rect.left + list.clientLeft;
      const rtl = getComputedStyle(list).direction === 'rtl';

      return list.scrollLeft + (rtl
        ? itemRect.right - (left + list.clientWidth)
        : itemRect.left - left);
    }

    function scrollToItem(item, smooth = true) {
      if (!item || !nativeMode) return;

      list.scrollTo({
        left: scrollOffset(item),
        behavior: smooth && !reducedMotion.matches ? 'smooth' : 'instant',
      });
    }

    function closestItem() {
      let nearest = null;
      let distance = Infinity;

      for (const item of nativeEntries) {
        const delta = Math.abs(scrollOffset(item) - list.scrollLeft);

        if (delta < distance) {
          nearest = item;
          distance = delta;
        }
      }

      return nearest;
    }

    function updateNativeSelection(item) {
      if (!item) return;

      const changed = !item.classList.contains('is-active');

      Array.from(list.children).forEach(entry => {
        if (entry.hasAttribute('data-media-id')) {
          entry.classList.toggle('is-active', entry === item);
        }
      });

      renderDots(dots, nativeEntries);

      // Synchronize the hidden thumbnails without scrolling the document.

      gallery.elements.thumbnails?.querySelectorAll('[data-target]').forEach(entry => {
        const control = entry.querySelector('button');
        if (!control) return;

        if (entry.dataset.target === item.dataset.mediaId) {
          control.setAttribute('aria-current', 'true');
        } else {
          control.removeAttribute('aria-current');
        }
      });

      if (changed) {
        gallery.playActiveMedia(item);
      }

      clearTimeout(announceTimer);

      announceTimer = window.setTimeout(() => {
        if (signal.aborted || !gallery.elements.liveRegion) return;

        gallery.elements.liveRegion.setAttribute('aria-hidden', 'false');

        gallery.elements.liveRegion.textContent =
          `${labels.image} ${nativeEntries.indexOf(item) + 1} / ${nativeEntries.length}`;
      }, 180);
    }

    function refresh() {
      const entries = sourceItems();

      if (!entries.some(item => item.classList.contains('is-active'))) {
        entries[0]?.classList.add('is-active');
      }

      if (nativeMode) {
        nativeEntries = entries;
        const visible = new Set(entries);

        Array.from(list.children).forEach(item => {
          if (item.hasAttribute('data-media-id')) {
            item.setAttribute(
              'data-bz-visible',
              String(visible.has(item))
            );
          }
        });

        setNativeHeight();
      }

      previous.hidden = next.hidden = entries.length < 2;
      renderDots(dots, entries);

      if (!nativeMode) {
        viewer.resetPages?.();
      }

      if (dialog?.open) {
        renderLightbox();
      }
    }

    gallery.setActiveMedia = function(mediaId, prepend) {
      const target = Array.from(list.children).find(
        item => item.dataset.mediaId === String(mediaId)
      );

      if (!target) return;

      if (!nativeMode) {
        originalSetActiveMedia.call(this, mediaId, prepend);
        refresh();
        return;
      }

      // Do not call Dawn's method here: it schedules its own scroll and would
      // compete with native dragging/snap. Variant updates still select media.

      Array.from(list.children).forEach(item => {
        if (item.hasAttribute('data-media-id')) {
          item.classList.toggle('is-active', item === target);
        }
      });

      if (prepend) {
        list.prepend(target);

        const thumbnail = Array.from(
          this.elements.thumbnails?.querySelectorAll('[data-target]') || []
        ).find(item => item.dataset.target === String(mediaId));

        if (thumbnail) {
          thumbnail.parentElement.prepend(thumbnail);
        }
      }

      refresh();
      updateNativeSelection(target);
      this.playActiveMedia(target);
      this.preventStickyHeader();

      pendingTarget = target;
      clearTimeout(pendingTimer);

      pendingTimer = window.setTimeout(() => {
        pendingTarget = null;
      }, 1000);

      scrollToItem(target, !prepend && !dialog?.open);
    };

    const wrappedSetActiveMedia = gallery.setActiveMedia;

    const select = item => {
      return item && gallery.setActiveMedia(item.dataset.mediaId, false);
    };

    function move(direction, fullscreen = false) {
      const entries = fullscreen ? photos() : items();

      if (entries.length < 2) return;

      const index = entries.indexOf(active());

      const nextIndex = nativeMode && !fullscreen
        ? Math.max(
            0,
            Math.min(entries.length - 1, Math.max(0, index) + direction)
          )
        : (Math.max(0, index) + direction + entries.length) % entries.length;

      select(entries[nextIndex]);
    }

    press(previous, () => move(-1));
    press(next, () => move(1));

    const chooseDot = event => {
      const dot = event.target.closest('button[data-media-id]');

      if (dot) {
        select(
          items().find(item => item.dataset.mediaId === dot.dataset.mediaId)
        );
      }
    };

    press(dots, chooseDot);

    function gestures(surface, fullscreen = false) {
      let start;
      const isNative = () => nativeMode && !fullscreen;

      listen(surface, 'dragstart', event => {
        if (event.target.closest('img')) {
          event.preventDefault();
        }
      });

      listen(surface, 'pointerdown', event => {
        if (!event.isPrimary) {
          start = null;
          gallery.classList.remove('bz-mouse-dragging');
          return;
        }

        if (
          event.button !== 0 ||
          event.target.closest(
            '.bz-arrow, .bz-close, .bz-dot, video, iframe, model-viewer, deferred-media'
          )
        ) return;

        if (isNative()) {
          pendingTarget = null;
          clearTimeout(pendingTimer);
        }

        start = {
          id: event.pointerId,
          x: event.clientX,
          y: event.clientY,
          scrollLeft: list.scrollLeft,
          dragging: false,
        };
      });

      listen(surface, 'pointermove', event => {
        if (!start || start.id !== event.pointerId) return;

        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;

        if (isNative()) {
          if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
            suppressClickUntil = Date.now() + 500;

            if (event.pointerType === 'mouse') {
              start.dragging = true;
              gallery.classList.add('bz-mouse-dragging');

              surface.setPointerCapture?.(event.pointerId);

              event.preventDefault();
              list.scrollLeft = start.scrollLeft - dx;
            }
          }

          // Never preventDefault or capture a touch pointer: let iOS pan/pinch.
          return;
        }

        if (
          event.pointerType === 'mouse' &&
          Math.abs(dx) > 10 &&
          Math.abs(dx) > Math.abs(dy)
        ) {
          surface.setPointerCapture?.(event.pointerId);
        }
      });

      listen(surface, 'pointercancel', () => {
        const wasDragging = start?.dragging;
        start = null;

        gallery.classList.remove('bz-mouse-dragging');

        if (wasDragging && isNative()) {
          scrollToItem(closestItem());
        }
      });

      listen(surface, 'pointerup', event => {
        if (!start || start.id !== event.pointerId) return;

        const saved = start;
        start = null;

        if (isNative()) {
          gallery.classList.remove('bz-mouse-dragging');

          if (saved.dragging) {
            suppressClickUntil = Date.now() + 500;
            scrollToItem(closestItem());
          }

          return;
        }

        const dx = event.clientX - saved.x;
        const dy = event.clientY - saved.y;

        if (
          Math.abs(dx) < 45 ||
          Math.abs(dx) < Math.abs(dy) * 1.4
        ) return;

        suppressClickUntil = Date.now() + 500;

        window.setTimeout(() => {
          if (!signal.aborted) {
            move(dx < 0 ? 1 : -1, fullscreen);
          }
        }, 0);
      });

      listen(surface, 'click', event => {
        if (
          Date.now() < suppressClickUntil &&
          !event.target.closest('.bz-arrow, .bz-close, .bz-dot')
        ) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true });

      listen(surface, 'keydown', event => {
        if (
          event.target.closest('input, textarea, select, video, model-viewer')
        ) return;

        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();

          const rtl = getComputedStyle(list).direction === 'rtl';
          const direction = event.key === 'ArrowRight' ? 1 : -1;

          move(
            rtl && !fullscreen ? -direction : direction,
            fullscreen
          );
        }
      });
    }

    gestures(viewer);

    listen(list, 'scroll', () => {
      if (!nativeMode || dialog?.open || resizing) return;

      suppressClickUntil = Date.now() + 250;

      if (scrollFrame) return;

      scrollFrame = requestAnimationFrame(() => {
        scrollFrame = 0;

        if (signal.aborted || !nativeMode || dialog?.open) return;

        if (pendingTarget) {
          if (
            Math.abs(scrollOffset(pendingTarget) - list.scrollLeft) > 2
          ) return;

          pendingTarget = null;
          clearTimeout(pendingTimer);
        }

        updateNativeSelection(closestItem());
      });
    }, { passive: true });

    function resizeNative() {
      if (resizeFrame) {
        cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = 0;

        if (signal.aborted || !nativeMode || !list.clientWidth) return;

        const width = list.clientWidth;

        if (Math.abs(width - lastWidth) < 0.5) return;

        lastWidth = width;
        resizing = true;

        setNativeHeight();
        scrollToItem(active(), false);

        requestAnimationFrame(() => {
          resizing = false;
        });
      });
    }

    function updateMode() {
      nativeMode = mobileQuery.matches;

      gallery.classList.toggle('bz-native-swipe', nativeMode);
      gallery.classList.remove('bz-mouse-dragging');

      pendingTarget = null;
      clearTimeout(pendingTimer);
      lastWidth = 0;

      if (!nativeMode) {
        list.style.removeProperty('--bz-native-height');
        list.scrollTo({ left: 0, behavior: 'instant' });

        Array.from(list.children).forEach(item => {
          item.removeAttribute('data-bz-visible');
        });
      }

      refresh();

      if (nativeMode) {
        resizeNative();
      }
    }

    listen(mobileQuery, 'change', updateMode);
    listen(window, 'resize', resizeNative, { passive: true });

    const sizeObserver = typeof ResizeObserver === 'function'
      ? new ResizeObserver(resizeNative)
      : null;

    sizeObserver?.observe(list);

    function renderLightbox() {
      const source = active() && photo(active());

      if (!source) {
        dialog.close();
        return;
      }

      if (lightboxImage.dataset.mediaId !== active().dataset.mediaId) {
        let image = lightboxImage.querySelector('img');

        if (!image) {
          image = document.createElement('img');
          image.loading = 'eager';
          image.sizes = '100vw';
          image.draggable = false;
          lightboxImage.append(image);
        }

        for (const attribute of ['src', 'srcset', 'alt', 'width', 'height']) {
          const value = source.getAttribute(attribute);

          if (value === null) {
            image.removeAttribute(attribute);
          } else {
            image.setAttribute(attribute, value);
          }
        }

        lightboxImage.dataset.mediaId = active().dataset.mediaId;
      }

      lightboxPrevious.hidden = lightboxNext.hidden = photos().length < 2;
      renderDots(lightboxDots, photos());
    }

    function openLightbox(trigger) {
      if (!dialog) {
        dialog = document.createElement('dialog');

        if (typeof dialog.showModal !== 'function') {
          dialog = null;
          return false;
        }

        dialog.className = 'bz-lightbox';
        dialog.setAttribute('aria-label', labels.gallery);

        const close = button(
          'bz-close',
          labels.close,
          'M5 5 L19 19 M19 5 L5 19'
        );

        lightboxImage = document.createElement('div');
        lightboxImage.className = 'bz-lightbox-image';

        lightboxPrevious = button(
          'bz-arrow bz-previous',
          labels.previous,
          'M15 4 L7 12 L15 20'
        );

        lightboxNext = button(
          'bz-arrow bz-next',
          labels.next,
          'M9 4 L17 12 L9 20'
        );

        lightboxDots = document.createElement('div');
        lightboxDots.className = 'bz-dots';

        dialog.append(
          close,
          lightboxImage,
          lightboxPrevious,
          lightboxNext,
          lightboxDots
        );

        document.body.append(dialog);

        press(close, event => {
          suppressClickUntil = Date.now() + 500;

          if (event.type === 'pointerup') {
            suppressCloseClickUntil = Date.now() + 700;
          }

          dialog.close();
        });

        press(lightboxPrevious, () => move(-1, true));
        press(lightboxNext, () => move(1, true));
        press(lightboxDots, chooseDot);

        listen(dialog, 'close', () => {
          document.body.classList.remove('bz-lightbox-open');

          const focusTarget =
            active()?.querySelector('.product__media-toggle') || opener;

          if (focusTarget?.isConnected) {
            focusTarget.focus({ preventScroll: true });
          }
        });

        gestures(dialog, true);
      }

      opener = trigger;
      renderLightbox();
      dialog.showModal();
      document.body.classList.add('bz-lightbox-open');

      return true;
    }

    listen(viewer, 'click', event => {
      const imageOpener = event.target.closest('.product__modal-opener--image');

      if (
        !imageOpener ||
        !photo(imageOpener.closest('[data-media-id]'))
      ) return;

      if (nativeMode) {
        const clickedItem = imageOpener.closest('[data-media-id]');

        if (clickedItem && nativeEntries.includes(clickedItem)) {
          updateNativeSelection(clickedItem);
        }
      }

      if (openLightbox(imageOpener.querySelector('button') || imageOpener)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, { capture: true });

    const observer = new MutationObserver(() => {
      refresh();

      if (nativeMode) {
        scrollToItem(active(), false);
      }
    });

    observer.observe(list, { childList: true });

    instances.set(gallery, () => {
      if (dialog?.open) {
        document.body.classList.remove('bz-lightbox-open');
      }

      dialog?.close();
      dialog?.remove();

      controller.abort();
      observer.disconnect();
      sizeObserver?.disconnect();

      cancelAnimationFrame(scrollFrame);
      cancelAnimationFrame(resizeFrame);
      clearTimeout(announceTimer);
      clearTimeout(pendingTimer);

      list.style.removeProperty('--bz-native-height');

      Array.from(list.children).forEach(item => {
        item.removeAttribute('data-bz-visible');
      });

      previous.remove();
      next.remove();
      dots.remove();

      gallery.classList.remove(
        'bz-gallery',
        'bz-native-swipe',
        'bz-mouse-dragging'
      );

      if (gallery.setActiveMedia === wrappedSetActiveMedia) {
        gallery.setActiveMedia = originalSetActiveMedia;
      }

      instances.delete(gallery);
    });

    refresh();

    if (nativeMode) {
      resizeNative();
    }
  }

  function galleries(root) {
    return [
      ...(root.matches?.('media-gallery') ? [root] : []),
      ...root.querySelectorAll('media-gallery'),
    ];
  }

  function start(root = document) {
    galleries(root).forEach(mount);
  }

  customElements.whenDefined('media-gallery').then(() => start());

  document.addEventListener('shopify:section:load', event => {
    start(event.target);
  });

  document.addEventListener('shopify:section:unload', event => {
    galleries(event.target).forEach(gallery => {
      instances.get(gallery)?.();
    });
  });
})();